import { useEffect, useRef } from "react";
import { isEqual } from "lodash";

export default function useDeepEffect(effectFunc, deps) {
  const isFirst = useRef(true);
  const prevDeps = useRef(deps);
  const effectRef = useRef(effectFunc);
  effectRef.current = effectFunc;

  useEffect(() => {
    const isSame = prevDeps.current.every((obj, index) =>
      isEqual(obj, deps[index])
    );
    if (isFirst.current || !isSame) {
      effectRef.current();
    }

    isFirst.current = false;
    prevDeps.current = deps;
  }, [deps]);
}
